import { Box, Button, Grid } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CreateDestinationFormValues } from '../../organisms/create-destination/create-destination-form';

import CautionCard from '@/components/atoms/caution-card';
import { InputField } from '@/components/atoms/input-field';
import StepTitle from '@/components/atoms/step-title';
import {
  CreateDestinationContext,
  CreateDestinationEvent,
} from '@/features/destinations/utils/machine/create-destination-machine';

interface Props {
  context: CreateDestinationContext;
  send: (event: CreateDestinationEvent) => void;
}

export const Translations = ({ context, send }: Props) => {
  const { t } = useTranslation(['createDestination', 'destination', 'common']);

  const { control } = useFormContext<CreateDestinationFormValues>();

  return (
    <div>
      <Box
        sx={{
          display: 'grid',
          gap: 1,
          gridAutoFlow: 'row',
        }}>
        <StepTitle
          title={t('common:stepTitle', {
            step: context.step,
            title: t(context.content),
          })}
        />

        <CautionCard
          title={t('common:optional')}
          description={t('createDestination:optionalStepDescription')}
          sx={{ mb: 2 }}
        />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Controller
              control={control}
              name="translations.pl"
              render={({ field, fieldState: { error } }) => (
                <InputField
                  {...field}
                  fullWidth
                  label={t('destination:translations.polish')}
                  error={!!error?.message}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              control={control}
              name="translations.en"
              render={({ field, fieldState: { error } }) => (
                <InputField
                  {...field}
                  fullWidth
                  label={t('destination:translations.english')}
                  error={!!error?.message}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              control={control}
              name="translations.ua"
              render={({ field, fieldState: { error } }) => (
                <InputField
                  {...field}
                  fullWidth
                  label={t('destination:translations.ukrainian')}
                  error={!!error?.message}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
        </Grid>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 3,
          }}>
          <Button
            color="primary"
            onClick={() => send({ type: 'BACK' })}
            size="large"
            sx={{ mr: 2 }}
            type="button"
            variant="text">
            {t('common:button.back')}
          </Button>
          <Button
            color="primary"
            size="large"
            type="button"
            variant="contained"
            onClick={() => {
              send({ type: 'NEXT' });
            }}>
            {t('common:button.nextStep')}
          </Button>
        </Box>
      </Box>
    </div>
  );
};
